import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="before-unload-warning"
export default class extends Controller {
  static values = {
    formIsChanged: Boolean,
    leavingPageMessage: String,
  };

  connect() {
    window.addEventListener("beforeunload", this.leavingPage.bind(this));
    window.addEventListener("popstate", this.leavingPage.bind(this));
    window.addEventListener("turbo:before-visit", this.leavingPage.bind(this));
  }

  formIsChanged() {
    if (!this.formIsChangedValue) {
      this.formIsChangedValue = true;
    }
  }

  leavingPage(event) {
    if (this.formIsChangedValue) {
      if (event.type == "turbo:before-visit") {
        if (!window.confirm(this.leavingPageMessageValue)) {
          event.preventDefault();
        }
      } else {
        event.returnValue = this.leavingPageMessageValue;
        return event.returnValue;
      }
    }
  }

  allowFormSubmission() {
    this.formIsChangedValue = false;
  }

  disconnect() {
    window.removeEventListener("beforeunload", this.leavingPage.bind(this));
    window.removeEventListener("popstate", this.leavingPage.bind(this));
    window.removeEventListener("turbo:before-visit", this.leavingPage.bind(this));

    this.formIsChangedValue = false;
  }
}
